<template>
  <el-dialog
    append-to-body
    width="600px"
    :title="`${isChange ? '修改' : '新增'}`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="auto"
      label-position="left"
      :model="form.data"
      :rules="form.rules"
    >
      <!-- 新增 -->
      <el-form-item prop="type" label="学历">
        <el-select
          v-model="form.data.type"
          :disabled="isChange"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in diplomaOpt"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div class="el-form-item-msg" style="margin-bottom: 10px">
        针对不同类型学校简历，输入企业需消耗的人才币数量
      </div>
      <template v-if="form.data.type != 1">
        <el-form-item label="985类">
          <el-row>
            <el-col :span="10">
              <el-form-item prop="985_read_coin" label="查看">
                <el-input
                  type="age"
                  v-model.number="form.data['985_read_coin']"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item prop="985_coin" label="下载">
                <el-input
                  type="age"
                  v-model.number="form.data['985_coin']"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="211类">
          <el-row>
            <el-col :span="10">
              <el-form-item prop="211_read_coin" label="查看">
                <el-input
                  type="age"
                  v-model.number="form.data['211_read_coin']"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item prop="211_coin" label="下载">
                <el-input
                  type="age"
                  v-model.number="form.data['211_coin']"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="padding-left: 10px">
              <el-button type="text" @click="toSame('211')">同上</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="双一流">
          <el-row>
            <el-col :span="10">
              <el-form-item prop="double_first_read_coin" label="查看">
                <el-input
                  type="age"
                  v-model.number="form.data['double_first_read_coin']"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item prop="double_first_coin" label="下载">
                <el-input
                  type="age"
                  v-model.number="form.data['double_first_coin']"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="padding-left: 10px">
              <el-button type="text" @click="toSame('双一流')">同上</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </template>
      <el-form-item label="其他类">
        <el-row>
          <el-col :span="10">
            <el-form-item prop="read_coin" label="查看">
              <el-input
                type="age"
                v-model.number="form.data.read_coin"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="coin" label="下载">
              <el-input
                type="age"
                v-model.number="form.data.coin"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="padding-left: 10px" v-if="form.data.type != 1">
            <el-button type="text" @click="toSame('其他类')">同上</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import common from "@/util";
export default {
  name: "PlatformRuleEdit",
  props: ["diplomaList"],
  data() {
    return {
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          type: "",
          "985_read_coin": "",
          "985_coin": "",
          "211_read_coin": "",
          "211_coin": "",
          double_first_read_coin: "",
          double_first_coin: "",
          read_coin: "",
          coin: "",
        },
        rules: {
          type: [{ required: true, message: "请选择学历", trigger: "change" }],
          "985_read_coin": [
            { required: true, message: "人才币不能为空" },
            { type: "number", message: "人才币只能输入整数" },
          ],
          "985_coin": [
            { required: true, message: "人才币不能为空" },
            { type: "number", message: "人才币只能输入整数" },
          ],
          "211_read_coin": [
            { required: true, message: "人才币不能为空" },
            { type: "number", message: "人才币只能输入整数" },
          ],
          "211_coin": [
            { required: true, message: "人才币不能为空" },
            { type: "number", message: "人才币只能输入整数" },
          ],
          double_first_read_coin: [
            { required: true, message: "人才币不能为空" },
            { type: "number", message: "人才币只能输入整数" },
          ],
          double_first_coin: [
            { required: true, message: "人才币不能为空" },
            { type: "number", message: "人才币只能输入整数" },
          ],
          read_coin: [
            { required: true, message: "人才币不能为空" },
            { type: "number", message: "人才币只能输入整数" },
          ],
          coin: [
            { required: true, message: "人才币不能为空" },
            { type: "number", message: "人才币只能输入整数" },
          ],
        },
      },
      curDiplomaList: [],
      addDiplomaOpt: [],
      diplomaOpt: [
        {
          id: 1,
          name: "大专",
        },
        {
          id: 2,
          name: "本科",
        },
        {
          id: 3,
          name: "硕士",
        },
        {
          id: 4,
          name: "博士",
        },
      ],
    };
  },
  watch: {
    // diplomaList(val) {
    //   this.curDiplomaList = val;
    //   // 过滤出未添加过的学历
    //   let arr = this.diplomaOpt.filter(
    //     (item) => !this.curDiplomaList.some((ele) => ele === item.name)
    //   );
    //   this.addDiplomaOpt = arr;
    // },
  },
  methods: {
    toSame(type) {
      if(type == '211'){
        this.form.data['211_read_coin'] = this.form.data['985_read_coin'];
        this.form.data['211_coin'] = this.form.data['985_coin']
      }else if(type == '双一流'){
        this.form.data['double_first_read_coin'] = this.form.data['211_read_coin'];
        this.form.data['double_first_coin'] = this.form.data['211_coin']
      }else if(type == '其他类'){
        this.form.data.read_coin = this.form.data['double_first_read_coin'];
        this.form.data.coin = this.form.data['double_first_coin']
      }
    },
    // 获取详情
    getDetail(row) {
      this.isChange = true;
      common.deepClone(this.form.data, row);
      this.form.data.type = row.type_id;
    },
    reset(done) {
      this.isChange = false;
      this.form.data = {
        type: "",
        "985_read_coin": "",
        "985_coin": "",
        "211_read_coin": "",
        "211_coin": "",
        double_first_read_coin: "",
        double_first_coin: "",
        read_coin: "",
        coin: "",
      };
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let apiUrl = !this.isChange ? "/admin/rule/add" : "/admin/rule/edit";
          this.$http
            .post(apiUrl, this.form.data)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功");
                this.toggle(false);
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isLt5M;
    },
    httpRequest(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.$http
        .post("common/qiniu/uploadFile", { formData, type: "upload" })
        .then((res) => {
          this.form.data.id_card = res.data.all_path_url;
        });
    },
    handleAccountChange(id) {
      let arr = this.userListOpt.filter((item) => {
        return item.id === id;
      });
      this.form.data.name = arr[0].nickname;
      this.form.data.account = arr[0].account;
      this.isdisabled = true;
    },
    dataFilter(val) {
      this.form.data.account = val;
      this.form.data.name = "";
      this.isdisabled = false;
      this.form.rules.name = [
        { required: true, message: "请输入代理姓名", trigger: "blur" },
      ];
    },
  },
};
</script>
